module.exports = __webpack_public_path__ + "static/RooBot2-327c1ba9989902c7407696ca9ef7f145.png";